import { useId } from "react";
import './input-toggle.css'
import { clsx } from "../../functions";
import { inputOnKeyUp } from "../../functions.ts";

export default function ToggleInput (props: {
	label: string,
	value: boolean,
  image: string,
  onChange: (value: boolean) => void,
}){
  const id = useId();
  return <div 
          className={"toggle-input"}
          id={id}
          onClick={()=>{props.onChange(!props.value);}}
          onKeyUp={(event)=> inputOnKeyUp(event, ()=>{ props.onChange(!props.value); })}
          tabIndex={0}
        >
        <div 
          style={{backgroundImage: "url("+props.image+")"}} 
          className={clsx("toggle-input__button", props.value && "toggle-input__button--active")} 
        />
        <label className={"toggle-input__label input__label"}  htmlFor={id}>{props.label}</label>
    </div>
}